import SuccessIcon from 'components/SuccessIcon/SuccessIcon';
import dictionary from 'config/dictionary';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {
  fetchStatus,
  getSelectedAccount,
  getPaymentValue,
} from 'redux/modules/bankPayment';
import { getHuggg } from 'redux/modules/huggg';
import { getVoucherAmount } from 'utilities/huggg';
import { interpolateMany } from 'utilities/interpolate';
import styles from './bankPayment.module.scss';

const maskAccount = (accountNumber) => {
  if (!accountNumber) return null;
  const digits = accountNumber.replace(/\D+/g, '');
  if (digits.length < 4) return null;
  return `•••• ${digits.slice(-4)}`;
};

export const BankPaymentSuccessUnconnected = ({
  hugggId,
  paymentValue,
  selectedAccount,
  fetchStatus,
}) => {
  // The success screen often mounts on a hard-reload of /:shortcode/redeemed
  // where BankPaymentRedemption never ran — so the bankPayment slice has no
  // value yet. One-shot fetch fills it on mount.
  useEffect(() => {
    if (hugggId && paymentValue == null && fetchStatus) {
      fetchStatus(hugggId);
    }
  }, [hugggId, paymentValue, fetchStatus]);

  const amount = getVoucherAmount({
    pence: paymentValue,
    alwaysShowDecimal: true,
  });
  const masked = selectedAccount && maskAccount(selectedAccount.accountNumber);

  const bodyTemplate = masked
    ? dictionary.bankPayment.success.bodyWithAccount
    : dictionary.bankPayment.success.bodyFallback;

  return (
    <div className={styles.container} data-test-id="bank-payment-success-view">
      <div className={styles.successIcon}>
        <SuccessIcon alt="Success" scale={0.8} />
      </div>
      <h2 className={styles.title}>{dictionary.bankPayment.success.title}</h2>
      <p className={styles.body}>
        {interpolateMany(bodyTemplate, [
          ['[amount]', <span key="amount">{amount}</span>],
          ['[account]', <span key="account">{masked}</span>],
        ])}
      </p>
      <p className={styles.arrival}>{dictionary.bankPayment.success.arrival}</p>
    </div>
  );
};

BankPaymentSuccessUnconnected.propTypes = {
  hugggId: PropTypes.string,
  paymentValue: PropTypes.number,
  selectedAccount: PropTypes.shape({
    accountNumber: PropTypes.string,
    sortCode: PropTypes.string,
    accountHolderName: PropTypes.string,
  }),
  fetchStatus: PropTypes.func,
};

const mapStateToProps = (state) => {
  const huggg = getHuggg(state);
  return {
    hugggId: huggg && huggg.id,
    paymentValue: getPaymentValue(state),
    selectedAccount: getSelectedAccount(state),
  };
};

export default connect(mapStateToProps, { fetchStatus })(
  BankPaymentSuccessUnconnected,
);
